var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessorTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.15,52.72a14.44,14.44,0,1,1-14.43-14.4A14.41,14.41,0,0,1,124.15,52.72ZM140.1,97.35a19.91,19.91,0,0,0-19.88-19.82H98.31A19.91,19.91,0,0,0,78.43,97.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.5,161.12h0v15.06H44.8V161.12h0A14.34,14.34,0,0,1,59.1,147.4s13.72-.07,14.42,13.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 59.16,
    cy: 123.75,
    r: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.36,161.12h0v15.06H93.67V161.12h0A14.35,14.35,0,0,1,108,147.4s13.71-.07,14.41,13.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.02,
    cy: 123.75,
    r: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.61,161.12h0v15.06H142.91V161.12h0a14.33,14.33,0,0,1,14.28-13.72s13.72-.07,14.42,13.72"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 157.26,
    cy: 123.75,
    r: 11.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessorTeacher);
export default __webpack_public_path__ + "static/media/PROFESSOR_TEACHER.38ee8aa7200d693e092bc6e434b4e43e.svg";
export { ForwardRef as ReactComponent };